/* SCRIPT SHOW MOBILE SLIDER ARROWS */
(function () {
  function forceMobileArrows() {
    var $slider = jQuery('#shopify-section-template--27915844813127__section_banner_v3_8Cmw63 .js-banner-v3');

    if (!$slider.length || typeof $slider.slick !== 'function') return;
    if (!$slider.hasClass('slick-initialized')) return;

    var isMobile = window.matchMedia('(max-width: 768px)').matches;
    if (!isMobile) return;

    try {
      // Slick Instanz + aktuelle Optionen holen
      var slick = $slider.slick('getSlick');
      if (!slick || !slick.options) return;

      // Wenn bereits arrows true, nichts tun
      if (slick.options.arrows === true) return;

      // arrows aktivieren und Slick neu rendern
      $slider.slick('slickSetOption', 'arrows', true, true);

      // Falls responsive settings arrows:false überschreiben -> dort ebenfalls fixen
      if (Array.isArray(slick.options.responsive)) {
        var resp = slick.options.responsive.map(function (bp) {
          if (!bp || !bp.settings) return bp;
          // alle breakpoints <= 768: arrows erzwingen
          if (bp.breakpoint && bp.breakpoint <= 768) {
            bp.settings.arrows = true;
          }
          return bp;
        });
        $slider.slick('slickSetOption', 'responsive', resp, true);
      }
    } catch (e) {
      // Fallback: nichts
    }
  }

  jQuery(document).ready(function () {
    forceMobileArrows();
    // nach kurzer Zeit nochmal (manche Themes initialisieren verzögert)
    setTimeout(forceMobileArrows, 300);
    setTimeout(forceMobileArrows, 900);
  });

  jQuery(window).on('resize orientationchange', function () {
    forceMobileArrows();
  });
})();


